module.exports = __webpack_public_path__ + "static/img/11.d8efe8f6.jpeg";